import { ChangeEvent } from 'react';
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import type { RadioGroupControlType } from '@features/effector-form/controls/radioGroup/types';
import { withControl } from '@features/effector-form/hoc/withControl';
import * as Styled from './styled';

export const RadioGroupControl = withControl<RadioGroupControlType>(
  ({
    value,
    setValue,
    error,
    label,
    required,
    disabled,
    readOnly,
    options = [],
    isError,
  }) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      setValue((event.target as HTMLInputElement).value);
    };

    return (
      <FormControl required={required} disabled={disabled}>
        {label && <FormLabel error={isError}>{label}</FormLabel>}
        <RadioGroup onChange={handleChange} value={value}>
          {options.map((option) => (
            <div key={option.id}>
              <FormControlLabel
                value={option.id}
                control={<Radio disabled={readOnly || disabled} />}
                label={option.label}
              />
              {option?.helperText && (
                <Styled.HelperText>{option.helperText}</Styled.HelperText>
              )}
            </div>
          ))}
        </RadioGroup>
        {error && <FormHelperText error>{error}</FormHelperText>}
      </FormControl>
    );
  }
);
